export default {
  radiostation: "0",
  dj: "1",
  star: "2",
  podcast: "3",
  video: "4",
};
